import { forwardRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { SuggestionKeyDownProps } from '@tiptap/suggestion';
import { getUserInfo } from 'Store/Auth/Auth.selector';
import { IUserData } from 'Data/interfaces/User/IUserData';
import { GetAvatar } from 'Utils/generateThumbnail';
import { Icon } from 'Components/UI';
import { SuggestionPropsType } from '../../userSuggestion';
import {
  DropdownMenu,
  EmptyContent,
  Footer,
  Header,
  MainContent,
} from './styles';

export enum SelectMentionUserGroupIdEnum {
  followers = 0,
  assigneds = 1,
}

export const mentionGroupUsersIds = [
  SelectMentionUserGroupIdEnum.followers,
  SelectMentionUserGroupIdEnum.assigneds,
];

export interface MentionListUserRef {
  onKeyDown: (props: SuggestionKeyDownProps) => boolean;
}

interface ICustomMentionProps {
  assignedUsers: IUserData[];
  followersUsers: IUserData[];
}

type MentionListUserProps = SuggestionPropsType & ICustomMentionProps;

const MentionListUser = forwardRef<MentionListUserRef, MentionListUserProps>((
  props,
  ref,
) => {
  const { t } = useTranslation('activities');
  const userInfo = useSelector(getUserInfo);
  const assignedUsers = props?.assignedUsers || [];
  const followersUsers = props?.followersUsers || [];

  const selectGroup = (groupId: SelectMentionUserGroupIdEnum) => {
    props?.command({ id: groupId.toString() });
  };

  const selectItem = useCallback((index: number) => {
    const item = props?.items[index];

    if (item) {
      props?.command({ id: item.Id as string })
    }
  }, [props]);

  return (
    <DropdownMenu>
      <Header>
        <button
          className="row"
          onMouseDown={(e) => {
            e.preventDefault();
            selectGroup(SelectMentionUserGroupIdEnum.followers);
          }}
        >
          <div className="iconContainer">
            <Icon icon="person" customSize={10} className="icon" />
          </div>
          <span className="textHeader">{t('mentions.allFollowers')}</span>
        </button>
        <button
          className="row"
          onMouseDown={(e) => {
            e.preventDefault();
            selectGroup(SelectMentionUserGroupIdEnum.assigneds);
          }}
        >
          <div className="iconContainer">
            <Icon icon="person" customSize={10} className="icon" />
          </div>
          <span className="textHeader">{t('mentions.allAssignees')}</span>
        </button>
      </Header>
      {props?.items?.length ? (
        <MainContent>
          {props?.items?.map((item, index) => {
            const isYou = userInfo?.Id === item?.Id;
            const isAssigned = assignedUsers.some(user => user.Id === item.Id);
            const isFollower = followersUsers.some(user => user.Id === item.Id);

            return (
              <button
                className="item"
                key={index}
                onMouseDown={(e) => {
                  e.preventDefault();
                  selectItem(index);
                }}
              >
                <div className="left">
                  <GetAvatar
                    src={item.OriginalImageUrl}
                    thumbSrc={item.ThumbnailImageUrl}
                    name={item.Nome || ''}
                    size={24}
                  />
                  <div className="LeftContent">
                    <span className="LeftContentName">{item.Nome}</span>
                    <span className="LeftContentEmail">{item.Email}</span>
                  </div>
                </div>
                <div className="right">
                  {isYou && <span className="tag">Você</span>}
                  {isFollower && (
                    <span className="tag">
                      <span className="tagIconContainer">
                        <Icon
                          icon="visualizar"
                          customSize={8}
                          className="tagIcon"
                        />
                      </span>
                      Seguindo
                    </span>
                  )}
                  {isAssigned && (
                    <span className="tag">
                      <span className="tagIconContainer">
                        <Icon
                          icon="menuGerenciarUsuario"
                          customSize={10}
                          className="tagIcon"
                        />
                      </span>
                      Responsável
                    </span>
                  )}
                </div>
              </button>
            )
          })}
        </MainContent>
      ) : (
        <EmptyContent>
          <Icon icon="person" customSize={16} className="iconEmpty" />
          <span className="textEmpty">{t('followers.noUserFound')}</span>
        </EmptyContent>
      )}
      <Footer>
        <span className="textFooter">'@' para Pessoas</span>
      </Footer>
    </DropdownMenu>
  )
})

export default MentionListUser;
